// extracted by mini-css-extract-plugin
module.exports = {"preTitle":"e_Fb","content":"e_Gb"};